// 日语配置
export default {
  title: 'MLB クラッチヒットベースボール｜公式サイト',
  pageMainId: '1', // 语言对应的parentId
  iconTextShow: '今すぐダウンロード！',
  bannerId: '6',
  downLinkArea: {
    apple: 'https://app.adjust.com/1crn00p3?campaign=iOSbutton',
    google: 'https://app.adjust.com/1cylwz8b?campaign=button_GP'
  },
  menu: [ // 菜单项配置
    {id: 'home',label: 'ホーム'},
    // {id: 'news',label: 'ニュース'},
    {id: 'feature',label: 'システム'},
    {id: 'activity',label: 'イベント'},
  ],
  page2: {
    title: 'ニュース',
    tabs: [
      {id: 'all',label: 'すべて'},
      {id: 'maintain',label: 'メンテナンス'},
      {id: 'announcement',label: 'お知らせ'},
      {id: 'activity',label: 'イベント'},
    ],
    tabLib: {
      all: '11',
      maintain: '14',
      announcement: '15',
      activity: '16'
    },
    tabLibColor: {
      14: '#268044',
      15: '#b30000',
      16: '#409EFF'
    },
    tabTagLib: {
      14: 'メンテナンス',
      15: 'お知らせ',
      16: 'イベント'
    }
  },
  page3: [
    {id:'1',title: "刺激なリアルタイムマッチ",content: '超爽快投打バトルを味い、刺激感と緊張感のある試合で勝利を目指しよう！',img: 'page3Banner1'},
    {id:'2',title: "豊富な育成システム",content: 'トップ選手を育ち、自分だけのオリジナルチームを作り上げよう！',img: 'page3Banner2'},
    {id:'3',title: "様々なイベント",content: '楽しさ満載のイベントに参加して豪華な報酬をゲットしよう！',img: 'page3Banner3'},
  ],
  page4: {
    title: 'イベント開催情報',
    getCardId: 10 // 拉取card时传的id
  },
  pageBottom: {
    logo: '', // 底部展示的logo
    ruleList: [
      {id: '1',label: '利用規約',url:'https://www.wildcaly.com/ToSJp.html'},
      {id: '2',label: 'プライバシーポリシー',url:'https://www.wildcaly.com/privacypolicyJp.html'},
      {id: '3',label: '特定商品取引法に基づき表示',url:'https://www.wildcaly.com/tradelaw.html'},
      {id: '4',label: '資金決済法に基づき表示',url:'https://www.wildcaly.com/shikin.html'},
    ],
    iconAndLink: [ // 图片和跳转
      {id: 'faceBook',imgName: 'faceBook',url: 'https://www.facebook.com/profile.php?id=61555208442634'},
      {id: 'twitter',imgName: 'twitter',url: 'https://twitter.com/clutch_hit_JP'},
      {id: 'email',imgName: 'email',url: 'mailto:chbservice@wildcaly.com'},
    ]
  }
}
